module.exports = __webpack_public_path__ + "img/index05.f5a53796.jpg";